import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

const CenteredBox = styled(Box)({
  flexGrow: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export default CenteredBox;
